/**
 * Created by filatov on 30.10.2015.
 */
import $ from 'jquery'
import {ChartSortOptions, ChartType, ReportGroupingLevel} from '../constants'
import ChartColorSelectorPanel from '../ChartColorSelectorPanel'
import ChartColorSelector from '../ChartColorSelector'
import ChartPercentsCheckbox from './ChartPercentsCheckbox'
import ChartTypeSelector from './ChartTypeSelector'
import ChartShowStackColumnsCheckbox from './ChartShowStackColumnsCheckbox'

export default class ChartDisplayParametersSectionController {

    init(chartDisplayParameters, groupingLevel, minChartPointValue, maxChartPointValue, changeCallback, showStackColumnsCheckMark) {
        this.createChartModeElement = $(".createChartModeElement ");

        this.changeCallback = changeCallback;
        this.showStackColumnsCheckMark = showStackColumnsCheckMark

        this.sortCategoryClasses = {date: "date", name: "name"}

        this.setParameters(chartDisplayParameters, groupingLevel);
        this.changeCheckboxStateIfNeededAndGetShowPercentsValue(minChartPointValue, maxChartPointValue);
        this.changeCheckboxStateIfNeededAndGetShowShowStackedColumnsValue()

        return this;
    }

    setParameters(chartDisplayParameters, groupingLevel) {
        const self = this;

        this.sortOption = {}
        this.sortOption.by = chartDisplayParameters.sortOption;
        this.sortOption.isAsc = chartDisplayParameters.sortOrderIsAsc;

        this.chartColorSelectorPanel = new ChartColorSelectorPanel().init(function() {self.chartColorSelector.updateOpenState(false)});
        this.chartColorSelector = new ChartColorSelector().init(
            "chartColorSelector",
            this.chartColorSelectorPanel,
            chartDisplayParameters.chartColor,
            function() {self.changeCallback()}
        )

        this.chartPercentsCheckbox = new ChartPercentsCheckbox().init(
            "chartShowPercents",
            function() {self.changeCallback()},
            chartDisplayParameters.showPercents
        )

        this.chartStackColumnsCheckbox = new ChartShowStackColumnsCheckbox().init(
            "chartShowStackedColumns",
            function() {self.changeCallback()},
            chartDisplayParameters.stackColumns
        )

        this.chartSortContainer = $("#chartSortContainer");
        this.chartSortContainer.removeClass();
        this.chartSortContainer.addClass("sortContainer");

        this.changeSortClassAccordingGroupingLevel(groupingLevel);
        this.changeSort(this.sortOption.by);
        this.initSortButtons();

        this.chartTypeSelector = new ChartTypeSelector().init("chartTypeSelector", chartDisplayParameters.chartType, self.changeCallback);

    }

    getSortOption() {
        return this.sortOption;
    }

    getChartType() {
        return this.chartTypeSelector.getChartType();
    }

    initSortButtons() {
        const self = this;
        this.chartSortContainer.find(".sortLink").off("click").on("click", function(event) {
            self.changeSort(event.target.id, true);
            if (self.changeCallback)
                self.changeCallback();
        })
    }

    changeSort(sortValue, changeSortOrder) {
        this.chartSortContainer.removeClass(this.getClassSortOption(this.sortOption.by));
        this.chartSortContainer.removeClass(this.sortOption.isAsc ? "asc" : "desc");

        if (changeSortOrder)
            this.sortOption.isAsc = !this.sortOption.isAsc;
        this.sortOption.isAsc = this.sortOption.by !== sortValue &&
                                (sortValue === ChartSortOptions.BY_VALUES
                                 || this.sortOption.by === ChartSortOptions.BY_VALUES) ? true : this.sortOption.isAsc;
        this.sortOption.by = sortValue;

        this.chartSortContainer.addClass(this.getClassSortOption(this.sortOption.by));
        this.chartSortContainer.addClass(this.sortOption.isAsc ? "asc" : "desc");
    }

    getClassSortOption(sortOptionBy) {
        const res = "sort";
        let cls = "";
        switch (sortOptionBy) {
            case  ChartSortOptions.ALPHABETICALLY:
                cls = "Alphabetically";
                break;
            case  ChartSortOptions.BY_VALUES:
                cls = "Values";
                break;
            case  ChartSortOptions.CHRONOLOGICALLY:
                cls = "Chronologically";
                break;
        }
        return res.concat(cls);
    }

    changeSortClassAccordingGroupingLevel(groupingLevel) {
        this.groupingLevel = groupingLevel
        this.createChartModeElement.removeClass(this.sortCategoryClasses.date);
        this.createChartModeElement.removeClass(this.sortCategoryClasses.name);
        switch (groupingLevel) {
            case ReportGroupingLevel.DATE:
            case ReportGroupingLevel.WEEK:
            case ReportGroupingLevel.MONTH: {
                this.createChartModeElement.addClass(this.sortCategoryClasses.date);
                if (this.sortOption.by !== ChartSortOptions.BY_VALUES) {
                    this.changeSort(ChartSortOptions.CHRONOLOGICALLY);
                }
                break;
            }
            case ReportGroupingLevel.USER:
            case ReportGroupingLevel.USER_GROUP:
            case ReportGroupingLevel.TIME_ZONE_GROUP:
            case ReportGroupingLevel.LEAVE_TYPE:
            case ReportGroupingLevel.CUSTOMER:
            case ReportGroupingLevel.PROJECT:
            case ReportGroupingLevel.BILLING_TYPE: {
                this.createChartModeElement.addClass(this.sortCategoryClasses.name);
                if (this.sortOption.by !== ChartSortOptions.BY_VALUES) {
                    this.changeSort(ChartSortOptions.ALPHABETICALLY);
                }
                break;
            }
        }
    }

    getChartColorId() {
        return this.chartColorSelector.getColorId()
    }

    isPercentsCheckboxVisibleAndChecked() {
        return this.chartPercentsCheckbox.isVisibleAndChecked();
    }

    isStackColumnsCheckboxVisibleAndChecked() {
        return this.chartStackColumnsCheckbox.isVisibleAndChecked();
    }

    getDisplayParameters() {
        return {
            showPercents: this.isPercentsCheckboxVisibleAndChecked(),
            sortOption: this.getSortOption().by,
            sortOrderIsAsc: this.getSortOption().isAsc,
            chartType: this.getChartType(),
            chartColor: this.chartColorSelector.getColorId(),
            stackColumns: this.isStackColumnsCheckboxVisibleAndChecked(),
        }
    }

    changeCheckboxStateIfNeededAndGetShowPercentsValue(minChartPointValue, maxChartPointValue) {
        if (this.getChartType() === ChartType.PIE_CHART || (minChartPointValue < 0 && maxChartPointValue > 0)) {
            this.chartPercentsCheckbox.hidePercentsCheckbox();
            return false;
        }
        else {
            this.chartPercentsCheckbox.showPercentsCheckbox();
            return this.chartPercentsCheckbox.getValue();
        }
    }

    changeCheckboxStateIfNeededAndGetShowShowStackedColumnsValue() {
        if (!this.showStackColumnsCheckMark || this.getChartType() === ChartType.PIE_CHART || this.groupingLevel === ReportGroupingLevel.USER) {
            this.chartStackColumnsCheckbox.hideStackColumnsCheckbox();
            return false;
        }
        else {
            this.chartStackColumnsCheckbox.showStackColumnsCheckbox();
            return this.chartStackColumnsCheckbox.getValue();
        }
    }

    static getDefaultDisplayParameters() {
        return {
            showPercents: false,
            sortOption: ChartSortOptions.ALPHABETICALLY,
            sortOrderIsAsc: true,
            chartType: ChartType.VERTICAL_BAR,
            chartColor: 'DEFAULT',
            stackColumns: false,
        }
    }
}



// WEBPACK FOOTER //
// ./web/js/reports/charts/ChartDisplayParametersSectionController.js